/**
 * Payment method options available in the registration flow
 */
export enum PaymentMethodEnum {
  CREDIT_CARD = 'credit_card',
  EPASSI = 'epassi',
  PAY_ON_SITE = 'pay_on_site',
}

/**
 * Payment method configuration
 */
export type PaymentMethod = {
  id: PaymentMethodEnum;
  label: string;
  disabled: boolean;
};

/**
 * Payment method to backend code mapping
 */
export const PAYMENT_METHOD_CODES = {
  [PaymentMethodEnum.CREDIT_CARD]: 1,
  [PaymentMethodEnum.EPASSI]: 97,
  [PaymentMethodEnum.PAY_ON_SITE]: 98,
} as const;